// eslint-disable-next-line
export default {
  main: "Ubuntu Regular",
  bold: "Ubuntu Bold",
}